import fetch from '../utils/fetch';
import store from '@/vuex/index';
import { needLoginHandler } from './handle';
// 获取会员资产信息
export function getMemberAssets() {
  // 个人中心卡券数据改造，需改用post请求，因前后端发版会有不同步，后端新加了一个接口
  // return fetch.get(`/order/api/shoppingCartPresent/getMemberAssets`);
  return fetch.post(`/order/api/shoppingCartPresent/getMemberAssetsNew`);
}
// // 获取订单的返利羊币信息
// export function getOrderBackCredit(orderId) {
//   return fetch.get('/soyoung/api/creditAccountDetail/getOrderBackCredit', { orderId });
// }

// 获取订单的返利羊币信息-会员等级调整接口变动
export function getOrderBackCredit(orderId) {
  return fetch.get('/shopmember/api/orderCreditLog/getOrderBackCredit', { orderId });
}
/**
 *会员卡下单
 *
 * @export
 * @returns
 */
export function orderCreateForInviteVipActivity(params) {
  return fetch.post('/order/api/order/createForInviteVipActivity', params);
}

/**
 *待付款订单状态
 *
 * @export
 * @returns
 */
export function orderConfirmVipCardOrderIsWaitPay(orderId) {
  return fetch.get('/order/api/order/confirmVipCardOrderIsWaitPay', { orderId });
}
export function shoppingCartPresentListExpireAll(params) {
  return fetch.post('/trade-main/api/shoppingCartPresent/listExpireAll', params);
}

export function shoppingCartPresentListUsedAll(params) {
  return fetch.post('/trade-main/api/shoppingCartPresent/listUsedAll', params);
}

export function orderPriceRemind(params) {
  return fetch.post('/trade-main/api/orderPrice/remind', params);
}

/**
 * 通过订单号获取该订单中满赠商品的信息如门槛等
 * @param {*} params
 * @returns
 */
export function orderListGiftByOrderId(params) {
  return fetch.get('/trade-main/api/order/listGiftByOrderId', params);
}

export function shoppingCartPresentDeleteByIds(params) {
  return fetch.post('/order/api/shoppingCartPresent/deleteByIds', params);
}

export function shoppingCartPresentListMyAll(params) {
  return fetch.post('/order/api/shoppingCartPresent/listMyAll', params);
}

export function lotteryOrderGetOrderDetail(params) {
  return fetch.get('/order/api/lotteryOrder/getOrderDetail', params);
}

export function lotteryOrderListMyLotteryPage(params) {
  return fetch.post('/order/api/lotteryOrder/listMyLotteryPage', params);
}

/**
 *创建订单
 *
 * @export
 * @param {*} postData
 * @returns
 */
export function orderCreate(postData) {
  // 读取推广员信息
  const { promoter } = store.state;
  if (promoter) {
    postData.promoterId = promoter;
  }
  return fetch.post('/order/api/order/create', postData);
}

/**
 *创建私域订单
 *
 * @export
 * @param {*} postData
 * @returns
 */
export function scrmSkinOrderCreate(postData) {
  return fetch.post('/order/api/scrmSkinOrder/create', postData);
}

// * 私域结算
export function skinOrderCalculatePayment(postData) {
  return fetch.post('/order/api/scrmSkinOrder/calculatePayment', postData);
}

export function orderListMyPage(
  postData = {
    pageNo: 0,
    pageSize: 10,
  }
) {
  return fetch.post('/order/api/order/listMyPage', postData).then(needLoginHandler);
}

/**
 * 获取订单列表
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E8%AE%A2%E5%8D%95%E6%9F%A5%E8%AF%A2/listMyOrderPageUsingPOST
 */

export function orderListMyPageV2(
  postData = {
    pageNo: 0,
    pageSize: 10,
  }
) {
  return fetch.post('/newretail/api/order/listMyOrderPage', postData).then(needLoginHandler);
}

export function orderGetVO(id) {
  return fetch.get(`/order/api/order/getVO?id=${id}`);
}
/**
 * 获取订单详情
 *  https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E8%AE%A2%E5%8D%95%E6%9F%A5%E8%AF%A2/getMyOrderUsingPOST
 */

export function orderGetVOV2(id) {
  return fetch.get(`/newretail/api/order/getMyOrder?id=${id}`);
}
/**
 * APP-获取订单对象
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E4%B8%AD%E5%BF%83-%E8%AE%A2%E5%8D%95%E6%9C%8D%E5%8A%A1/%E7%A7%BB%E5%8A%A8%E7%AB%AF/getVOUsingGET
 * @param {string} id
 * @returns
 */
export function orderGetVOByTransactionNo(transactionNo) {
  return fetch.get(`/order/api/order/getVOByTransactionNo?transactionNo=${transactionNo}`);
}

export function orderCancel(id) {
  return fetch.post(`/order/api/order/cancel?id=${id}`, {});
}

export function orderReceived(id) {
  return fetch.post('/order/api/order/received', id);
}

export function refundOrderCreate(postData) {
  return fetch.post('/order/api/refundOrder/create', postData);
}

export function refundOrderListMyPage(postData) {
  return fetch.post('/order/api/refundOrder/listMyPage', postData);
}

export function refundOrderGet(id) {
  return fetch.get('/order/api/refundOrder/get', id);
}

export function orderIsOrderCanRefund(id) {
  return fetch.get('/order/api/order/isOrderCanRefund', id);
}

export function refundOrderBuyerCancel(id) {
  return fetch.post(`/order/api/refundOrder/buyerCancel?id=${id}`, {});
}
export function refundOrderDelivered(postData) {
  return fetch.post('/order/api/refundOrder/delivered', postData);
}
export function orderPriceCalculateMaxRefundMoney(postData) {
  return fetch.post('/order/api/orderPrice/calculateMaxRefundMoney', postData);
}

/**
 * 支付成功后调用，更新订单状态为待付款确认
 * @param {string} id 订单ID
 */
export function orderPaid(id) {
  return fetch.post('/order/api/order/paid', id);
}

export function orderListDeliveriesByOrderId(id) {
  return fetch.get(`/order/api/order/listDeliveriesByOrderId?id=${id}`, {});
}

export function deliveryGet(deliveryCompanyCode, deliveryNumber) {
  return fetch.post('/order/api/orderDelivery/get', {
    deliveryCompanyCode,
    deliveryNumber,
  });
}

export function orderPriceCalculatePayment(postData) {
  return fetch.post('/order/api/orderPrice/calculatePayment', postData);
}
// 免登录算价接口，为了支付宝商详一体化组件
export function calculatePaymentAnon(postData) {
  return fetch.post('/order/api/orderPrice/calculatePaymentAnon', postData);
}

// * 礼包升级结算
export function orderPriceCalculateUpPresentPayment(postData) {
  return fetch.post('/order/api/orderPrice/calculateUpPresentPayment', postData);
}

// 拼团计算
export function grouponOrderCalculateAmount(postData) {
  return fetch.post('/order/api/grouponOrder/calculateAmount', postData);
}
// 拼团创建订单
export function grouponOrderCreate(postData) {
  const { promoter } = store.state;
  if (promoter) {
    postData.promoterId = promoter;
  }
  return fetch.post('/order/api/grouponOrder/create', postData);
}
/**
 * 删除订单
 * @param {String} id 订单ID
 */
export function orderDelete(id) {
  return fetch.post(`/order/api/order/delete?id=${id}`, {});
}

export function orderValidateBeforePay(id) {
  return fetch.get(`/order/api/order/validateBeforePay?id=${id}`);
}

export function grouponOrderListPage(pageNo = 0, pageSize = 10) {
  const postData = {
    data: {},
    pageNo,
    pageSize,
  };
  return fetch.post('/order/api/grouponOrder/listPage', postData);
}
export function grouponOrderGet(id) {
  return fetch.get(`/order/api/grouponOrder/get?id=${id}`);
}

export function grouponOrderCanceled(id) {
  return fetch.get(`/order/api/grouponOrder/canceled?id=${id}`);
}

export function orderUpdateCertificationAndReDeclare(orderId, name, idcardNo) {
  return fetch.post('/order/api/order/updateCertificationAndReDeclare', {
    orderId,
    name,
    idcardNo,
  });
}

export function payActivityGetPayActivityByOrderId(id) {
  return fetch.get(`/trade-main/api/payActivity/getPayActivityByOrderId?orderId=${id}`);
}

/**
 * V2.7 创建购买主动开卡订单
 *
 * @export
 * @param {*} postData
 * @returns
 */
export function orderCreateForInitiativeVipActivity(postData) {
  return fetch.post('/order/api/order/createForInitiativeVipActivity', postData);
}

/**
 * v2.23.1 退款之前检查风险
 * @param {String} orderId 订单orderId
 */
export function getRefundOrderRisk(orderId) {
  return fetch.get(`/order/api/refundOrder/checkRiskBeforeCreate?orderId=${orderId}`);
}

/**
 * v2.22.4
 * @param {*} postData
 * @returns
 */
export function orderUpdateOrderConsigneeAddress(consigneeAddressId, orderNo) {
  const postData = {
    consigneeAddressId: consigneeAddressId,
    id: orderNo,
  };
  return fetch.post('/order/api/order/updateOrderConsigneeAddress', postData);
}

export function orderGetOrderAddressById(id) {
  return fetch.get(`/order/api/order/getOrderAddressById?orderId=${id}`);
}

export function orderCommentCreate(orderId, commentDetails, orderNo) {
  const postData = {
    orderId: orderId,
    commentDetails,
    orderNo: orderNo,
  };
  return fetch.post('/order/api/orderComment/create', postData);
}

export function userConsigneeAddressGetVO(id) {
  return fetch.get(`/order/api/userConsigneeAddress/getVO?id=${id}`);
}

export function userConsigneeAddressCreate(postData) {
  return fetch.post('/order/api/userConsigneeAddress/create', postData);
}

export function userConsigneeAddressListMyAll() {
  return fetch.post('/order/api/userConsigneeAddress/listMyAll');
}

export function userConsigneeAddressDeleteByIds(id) {
  return fetch.post('/order/api/userConsigneeAddress/deleteByIds', [id]);
}

export function userConsigneeAddressSetAsDefault(id) {
  return fetch.post(`/order/api/userConsigneeAddress/setAsDefault?id=${id}`);
}

export function userConsigneeAddressUnsetAsDefault(id) {
  return fetch.post(`/order/api/userConsigneeAddress/unsetAsDefault?id=${id}`);
}

export function userConsigneeAddressGetMyDefault() {
  return fetch.get('/order/api/userConsigneeAddress/getMyDefault');
}

export function userConsigneeAddressUpdate(postData) {
  return fetch.post('/order/api/userConsigneeAddress/update', postData);
}

/**
 * 匿名领奖活动结算
 */
export function anonRewardOrderCalculatePayment(data) {
  return fetch.post('/order/api/anonRewardOrder/calculatePayment', data);
}

/** d
 * 匿名领奖活动创建订单
 */
export function anonRewardOrderCreate(data) {
  return fetch.post('/order/api/anonRewardOrder/create', data);
}

export function shoppingCartListMyAll() {
  return fetch.post('/newretail/api/shoppingCart/listMyAll', {});
}

// 免登录获取购物车列表商品详细数据
export function getCartListUnlogin(data) {
  return fetch.post('/order/api/shoppingCart/listAnonAll', data);
}

export function shoppingCartUpdateCommodityQuantity(id, newQuantity) {
  return fetch.post('/order/api/shoppingCart/updateCommodityQuantity', { id, newQuantity });
}

export function shoppingCartRemoveByIds(ids) {
  return fetch.post('/order/api/shoppingCart/removeByIds', ids);
}

export function shoppingCartAddToCart(skuId, quantity, commodityId, itemId) {
  // 有itemId参数就是跳用换购加购接口，否则是普通加购接口
  const url = itemId
    ? '/order/api/shoppingCart/addRedemptionToCart'
    : '/order/api/shoppingCart/addToCart';
  return fetch
    .post(url, { skuId, quantity, commodityId, ...(itemId && { itemId }) })
    .then(needLoginHandler);
}

// 批量商品添加到购物车
export function addToCartBatch(data) {
  return fetch.post('/order/api/shoppingCart/addToCartBatch', data);
}

// 判断商品未登录状态是否能加购
export function getGoodsAddEnable(data) {
  return fetch.post('/order/api/shoppingCart/ifCanAddToCart', data);
}

// 购物车v2.0 展示目前换购数量
export function listMemberRedemptionCart(data) {
  return fetch
    .post(`/order/api/shoppingCart/listMemberRedemptionCart?itemType=${data}`)
    .then(needLoginHandler);
}
export function getSpuCount() {
  return fetch.post('/order/api/shoppingCart/getSpuCount');
}

export function uaPaymentBlacklistListValidPaymentChannel() {
  return fetch.get(
    '/order/api/uaPaymentBlacklist/listValidPaymentChannel',
    {},
    {
      header: {
        'X-Biz-Code': 'GZHSHOP',
      },
    }
  );
}

export function scrmMemberSkinPlanGet(id) {
  return fetch.get(`/order/api/scrmMemberSkinPlan/queryPlanById?planId=${id}`);
}

// 建立方案和用户的关系
export function scrmMemberSkinPlanBindMember(id) {
  return fetch.post('/order/api/scrmMemberSkinPlan/bindMember', { planId: id });
}
// APP-视频号订单同步到微信
export function orderSyncOrderToWechat(data) {
  return fetch.post('/order/api/order/syncOrderToWechat', data);
}
// 延长收货
export function extendReceivingForAPP(orderId) {
  return fetch.post('/order/api/order/extendReceivingForApp', { orderId: orderId });
}

// 获取延长收货详情
export function getExtendReceiveInfoForApp(orderId) {
  return fetch.get(`/order/api/order/getExtendReceiveInfoForApp?orderId=${orderId}`);
}
// 查询注销协议是否可注销
export function cancelAssetsCheck() {
  return fetch.get(`/order/api/order/cancelAssetsCheck`);
}

// v3.11 获取需要计算支付宝支付优惠的商品
export function vouchersCommodityIds() {
  return fetch.get(`/order/api/orderPrice/vouchersCommodityIds`);
}
export function syncWxLiveOrderToWechat(data) {
  return fetch.post('/order/api/wxUnionOrder/syncWxLiveOrderToWechat', data);
}

export function getBaleActivityUseCount(id) {
  // 获取升级版一口价用户限制
  return fetch.get('/order/api/orderMarketing/getBaleActivityUseCount?activityId=' + id);
}

/**
 * 查询是否为超额用户
 * https://apidoc.syounggroup.com/doc.html#/%E4%BA%A4%E6%98%93%E5%B9%B3%E5%8F%B0/OrderGlobalExcessAmountUser/checkIfExcessUserUsingPOST
 * @returns  {*}
 */
export function orderGlobalExcessAmountUserCheckIfExcessUser(data) {
  return fetch.post('/order/api/orderGlobalExcessAmountUser/checkIfExcessUser', data);
}
